var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({attrs:{"loading":_vm.loading,"disabled":_vm.$attrs['disabled'] || _vm.loading},on:{"change":_vm.onChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }